// Đặt lại mật khẩu tạm cho chủ Shop cấp dưới trực tiếp (POST /network/units/:id/password) — như đặt lại mật khẩu nhân
// viên (settings/members/MembersTab.tsx): chủ Shop bị đăng xuất mọi thiết bị, đăng nhập lần sau phải đổi mật khẩu.
// Xong thì hiện khung để chép gửi cho chủ Shop (mật khẩu tạm chỉ hiện lần này).

import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { STAFF_TEMP_PASSWORD_MIN } from '@shoptrack/common/unit-permissions'
import { post } from '@/lib/api'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { CredentialsBox } from '@/components/settings/members/CredentialsBox'
import { browserRandom, makeTempPassword } from '@/components/settings/members/types'

export function ResetOwnerPasswordDialog({
  unit,
  onClose,
}: {
  unit: { id: string; name: string; owner: { name: string | null; phone: string | null } | null }
  onClose: () => void
}) {
  const [password, setPassword] = useState(() => makeTempPassword(browserRandom))
  const [done, setDone] = useState<{ name: string | null; phone: string | null } | null>(null)
  const ownerName = unit.owner?.name || unit.name
  const save = useMutation({
    mutationFn: () => post<{ ok: true; owner: { name: string | null; phone: string | null } }>(`/network/units/${encodeURIComponent(unit.id)}/password`, { password }),
    onSuccess: (r) => setDone(r.owner),
    onError: (e) => toast.error((e as Error).message),
  })
  return (
    <Dialog open onOpenChange={(v) => !v && !save.isPending && onClose()}>
      <DialogContent className="sm:max-w-md" aria-describedby={done ? undefined : 'reset-owner-pw-desc'}>
        <DialogHeader className="pr-8">
          <DialogTitle>{done ? 'Đã đặt lại mật khẩu' : 'Đặt lại mật khẩu'}</DialogTitle>
          {!done && <DialogDescription id="reset-owner-pw-desc">{`${ownerName} sẽ bị đăng xuất khỏi mọi thiết bị.`}</DialogDescription>}
        </DialogHeader>
        {done ? (
          <CredentialsBox name={done.name || ownerName} phone={done.phone ?? unit.owner?.phone ?? ''} password={password} />
        ) : (
          <div className="flex gap-2">
            <Input value={password} onChange={(e) => setPassword(e.target.value)} maxLength={100} className="h-11 font-mono desktop:h-9" aria-label="Mật khẩu tạm mới" autoComplete="off" />
            <Button type="button" variant="outline" className="h-11 shrink-0 desktop:h-9" onClick={() => setPassword(makeTempPassword(browserRandom))}>
              Tạo mới
            </Button>
          </div>
        )}
        <DialogFooter>
          {done ? (
            <Button type="button" onClick={onClose}>Đóng</Button>
          ) : (
            <>
              <Button type="button" variant="outline" onClick={onClose} disabled={save.isPending}>Hủy</Button>
              <Button type="button" onClick={() => save.mutate()} disabled={save.isPending || password.length < STAFF_TEMP_PASSWORD_MIN}>
                {save.isPending ? 'Đang lưu…' : 'Đặt lại'}
              </Button>
            </>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
